import { render, staticRenderFns } from "./addBlack.vue?vue&type=template&id=39a2046a&"
import script from "./addBlack.vue?vue&type=script&lang=js&"
export * from "./addBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports